import { zodValidator, type TypedFetch } from "@spiriidk/utils";

import {
  EnvironmentBuildResponseSchema,
  EnvironmentBuildSearchSchema,
} from "../../schemas/environment";

const getEnvironment = async (fetch: TypedFetch, signal?: AbortSignal) =>
  fetch("/enums/", {
    validateResponse: zodValidator(EnvironmentBuildResponseSchema),
    validateSearch: zodValidator(EnvironmentBuildSearchSchema, {
      build: "1",
      env: "1",
    }),
    signal,
  });

export { getEnvironment };
